import type { ServiceCreateForm, ServiceUpdateForm } from 'chaika-frontend-types/frontend-cms';
import type { ValidationParams } from '@components/types';

import { Validation } from '@utils/Validation';
import { translate } from '@chaika/i18n/helper';

export function validateServiceCreationParams({
    name = '',
    researchPreparationLink = '',
    category,
}: Partial<ServiceCreateForm>): ValidationParams {
    if (name.length === 0 || !category) {
        return {
            isValid: false,
            message: translate('nameCategoryRequiredText'),
        };
    }

    if (researchPreparationLink?.length > 0 && !Validation.isUrl(researchPreparationLink)) {
        return {
            isValid: false,
            message: translate('linkShouldBeLinkText'),
        };
    }

    return {
        isValid: true,
        message: '',
    };
}

export function validateServiceUpdateParams({
    name,
    researchPreparationLink,
    category,
}: Partial<ServiceUpdateForm>): ValidationParams {
    if (!name || name.length === 0 || !category) {
        return {
            isValid: false,
            message: translate('nameCategoryRequiredText'),
        };
    }

    if (researchPreparationLink && researchPreparationLink?.length > 0 && !Validation.isUrl(researchPreparationLink)) {
        return {
            isValid: false,
            message: translate('linkShouldBeLinkText'),
        };
    }

    return {
        isValid: true,
        message: '',
    };
}
